import { Media } from 'lib-shared-types-channels';
import { memo } from 'react';

import { dashboardApi } from 'apis/dashboard';
import { mediaAttributes } from 'utils/channels/media';

import styles from './channelDashboardChannels.module.scss';
import { ChannelDashboardChannel } from './components/channel/channelDashboardChannel';

export const ChannelDashboardChannels = memo(
  function ChannelDashboardChannels(): JSX.Element {
    const { metrics, isFetching } =
      dashboardApi.endpoints.readChannelDashboardMetrics.useQueryState(
        undefined,
        {
          selectFromResult: ({ data, ...rest }) => ({
            ...rest,
            metrics: data?.data.channel_metrics ?? [],
          }),
        },
      );

    return (
      <div className={styles.cards}>
        {Object.entries(mediaAttributes).map(([media]) => (
          <ChannelDashboardChannel
            key={media}
            media={media as Media}
            isSkeleton={isFetching}
            metrics={metrics.find(({ id }) => id === media)?.metrics}
          />
        ))}
      </div>
    );
  },
);
